import { Link, createFileRoute, redirect } from '@tanstack/react-router'
import { ArrowLeft } from 'lucide-react'
import { getV1MeRetrieveQueryOptions } from '@/api/client'
import { PageHeader } from '@/components/page-header'
import { Button } from '@/components/ui/button'
import { ModuleAuditTable } from '@/components/modules/module-audit-table'

export const Route = createFileRoute('/_panel/moduly/historia')({
  beforeLoad: async ({ context }) => {
    // Same cut as the module config view (TR-1200 R6/R12): superadmin + admin only.
    const me = await context.queryClient.ensureQueryData(getV1MeRetrieveQueryOptions())
    if (me.status === 200 && me.data.role !== 'superadmin' && me.data.role !== 'admin') {
      throw redirect({ to: '/' })
    }
  },
  component: ModulesHistoryPage,
})

function ModulesHistoryPage() {
  return (
    <>
      <PageHeader
        title={
          <span className="flex items-center gap-3">
            <Button asChild variant="ghost" size="icon" aria-label="Wróć do zarządzania modułami">
              <Link to="/moduly">
                <ArrowLeft />
              </Link>
            </Button>
            Historia zmian modułów
          </span>
        }
      />
      <div className="p-6">
        <ModuleAuditTable />
      </div>
    </>
  )
}
